<template>
  <div>
    <a-row :gutter="8" style="margin-top: 20px">
      <a-col span="4" id="dd">
        <div class="search-title">{{ $t("createTime") }}</div>
        <a-range-picker v-model:value="search.times" style="width: 100%"/>
      </a-col>
      <a-col span="3">
        <div class="search-title">{{ $t("belongUser") }}</div>
        <select-id-and-name :list="userList" option-value="id" option-text="name"
        v-model:value="search.belongUser"></select-id-and-name>
      </a-col>
      <a-col span="3">
        <div class="search-title">{{ $t("taskIndex") }}</div>
        <a-input v-model:value="search.taskIndex" style="width: 100%" allow-clear/>
      </a-col>

      <a-col span="3">
        <div class="search-title">{{ $t("animalType") }}</div>
        <select-id-and-name :list="animalTypeList" option-value="id" option-text="name"
                            v-model:value="search.animalType"></select-id-and-name>
      </a-col>

      <a-col span="3">
        <div class="search-title">{{ $t("geneName") }}</div>
        <a-input v-model:value="search.geneName" style="width: 100%" allow-clear/>
      </a-col>

      <a-col span="4">
        <div class="search-title">{{ $t("editType") }}</div>
        <select-id-and-name :list="editTypeList" option-value="id" option-text="name"
                            v-model:value="search.editType" sort-by="id"></select-id-and-name>
      </a-col>

      <a-col span="4">
        <div class="search-title">{{ $t("status") }}</div>
        <select-id-and-name :list="statusList" option-value="id" option-text="name"
                            v-model:value="search.status" sort-by="id"></select-id-and-name>
      </a-col>
    </a-row>
    <div style="width: 100%;text-align: right;margin-top: 10px">
      <a-button-group>
        <a-button type="primary" @click="changeSearch('search')" style="margin: 0 0">
          <template #icon>
            <SearchOutlined />
          </template>
          {{ $t("search") }}
        </a-button>
        <a-button type="primary" @click="reset"  style="margin: 0 0">
          <template #icon>
            <RollbackOutlined />
          </template>
          {{ $t("reset") }}
        </a-button>
      </a-button-group>
    </div>
  </div>
</template>

<script>
import { SearchOutlined, RollbackOutlined } from '@ant-design/icons-vue';
import util from "@/util/util";
import SelectIdAndName from "@/components/public/selectIdAndName";

export default {
  name: "taskSearch",
  components : {SelectIdAndName, SearchOutlined, RollbackOutlined},
  data(){
    return{
      search : {
        times : [null, null],
        belongUser : "",
        taskIndex : "",
        geneName : "",
        editType : "",
        status : "",
        animalType : "",
        start : null,
        end : null
      },
      type: "search",
      userList : [],
      groupList : [],
    }
  },
  mounted() {
    this.initPage();
  },
  methods : {
    initPage(){
      var that = this;
      util.$post("/home/search/init",{}, function (res){
        that.userList = res.userList;
      }, null, null )
    },
    reset(){
      this.type = "search";
      this.search = {
        times : [null, null],
        belongUser : "",
        taskIndex : "",
        geneName : "",
        editType : "",
        status : "",
        animalType : "",
        start : null,
        end : null
      }
      this.changeSearch('reset');
      this.initPage();
    },
    changeSearch(type){
      this.type = type;
      if (util.isNull(this.search.times)){
        this.search.start = null;
        this.search.end = null;
      }else {
        this.search.start = this.search.times[0];
        this.search.end = this.search.times[1];
      }
      this.$emit("changeSearch", this.search, this.type);
    }
  },
  computed:{
    editTypeList(){
      return util.editTypeList();
    },
    statusList(){
      return util.statusList();
    },
    animalTypeList(){
      return util.animalTypeList();
    }
  }
}
</script>

<style scoped>
.search-title{
  font-weight: bold;
  font-size: 18px;
  color: black;
}
</style>